import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../../../../lib/api-client";
import { ApiResult } from "../../../../types/ApiResult";

export const useMarkMessageAsRead = (onSuccess: () => void, onError: (error: string) => void) => {

    const { mutate, isLoading } = useMutation({
        mutationFn: async (notificationQueueID: number) => {
            return await apiClient.post("communication/mark-as-read", { notificationQueueID }) as ApiResult;
        },
        onSuccess: async (result) => {
            if (result.isSuccess)
                onSuccess();
            else
                onError('Error when marking the message as read: ' + result.errorMessage!);
        },
        onError(error) {
            onError(error as string);
        }
    });

    return {
        mutate, isLoading
    }
}
